import { createReactClient, studioProvider } from "@livepeer/react";

const livepeerApiKey = process.env.REACT_APP_LIVEPEER_KEY || null;

export const isLivepeerEnabled = !!livepeerApiKey;

let livepeerClient;
try {
  // try-catch because when the embed page is executed in another domain in chrome incognito, createReactClient will throw:
  // DOMException: Failed to read the 'localStorage' property from 'Window': Access is denied for this document.
  livepeerClient = createReactClient({ provider: studioProvider({ apiKey: livepeerApiKey }) });
} catch (e) {
  console.warn("failed to initialize livepeerClient", e);
}

export { livepeerClient };
